/**
 * Card markers the current bundle knows how to render. A new marker from a
 * newer shanks is the other half of a stale tab: the version probe may not
 * have fired yet, but the tool result already cannot be shown honestly.
 */ export const KNOWN_CARD_MARKERS = new Set([
    '_documentWrite',
    '_documentCreate',
    '_recordWrite',
    '_deliveryAction',
    '_download',
    '_publish',
    '_rfiDraft',
    '_sopWrite',
    '_evidenceBatch'
]);
// Every _requiresApproval value shanks emits that this bundle has a card for.
// A missing entry hides a working card behind the "update available" hint.
export const KNOWN_APPROVAL_TYPES = new Set([
    'document_write',
    'document_create',
    'publish',
    'delivery_action',
    'record_write',
    'question',
    'sop_write',
    'evidence_batch'
]);
const UNKNOWN_CARD_MARKER = /^_[a-z][A-Za-z0-9]*(?:Write|Create|Action|Card|Publish|Draft)$/;
export function unrecognizedToolResult(output) {
    if (!output || typeof output !== 'object') {
        return false;
    }
    const rec = output;
    const approval = rec._requiresApproval;
    if (typeof approval === 'string' && approval !== '' && !KNOWN_APPROVAL_TYPES.has(approval)) {
        return true;
    }
    for (const key of Object.keys(rec)){
        if (KNOWN_CARD_MARKERS.has(key)) {
            continue;
        }
        if (UNKNOWN_CARD_MARKER.test(key)) {
            return true;
        }
    }
    return false;
}
